import api from './client';

// Interview API
export const interviewAPI = {
  uploadDS160: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/interview/upload-ds160', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  startInterview: async (ds160FileUrl, parsedData, modelProvider = 'openai', modelName = 'gpt-4o-mini') => {
    const response = await api.post('/interview/start', {
      ds160_file_url: ds160FileUrl,
      parsed_data: parsedData,
      model_provider: modelProvider,
      model_name: modelName,
    });
    return response.data;
  },

  sendMessage: async (sessionId, message) => {
    const formData = new FormData();
    formData.append('message', message);
    
    const response = await api.post(`/interview/${sessionId}/message`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  completeInterview: async (sessionId) => {
    const response = await api.post(`/interview/${sessionId}/complete`);
    return response.data;
  },

  getSession: async (sessionId) => {
    const response = await api.get(`/interview/${sessionId}`);
    return response.data;
  },

  getHistory: async () => {
    const response = await api.get('/interview/history');
    return response.data;
  },

  getReplay: async (sessionId) => {
    const response = await api.get(`/interview/replay/${sessionId}`);
    return response.data;
  },
};

export default interviewAPI;
